import { createAction, props } from '@ngrx/store';
import { IResponseBadRequest } from '@core/interfaces';
import { DualPricing } from '@core/models'

export const DUAL_PRICING_FIND = createAction('[Dual Pricing] Find', props<{ id: string }>());

export const DUAL_PRICING_FIND_ALL = createAction('[Dual Pricing] Find All');
export const DUAL_PRICING_FIND_SUCCESS = createAction('[Dual Pricing] Find Success', props<{ dualPricing: DualPricing|null }>());
export const DUAL_PRICING_FIND_ALL_SUCCESS = createAction('[Dual Pricing] Find All Success', props<{ dualPricingList: DualPricing[] }>());

export const DUAL_PRICING_FAILURE = createAction('[Dual Pricing] Failure', props<{ error: IResponseBadRequest }>());

export const DUAL_PRICING_RESET = createAction('[Dual Pricing] Reset');
export const DUAL_PRICING_CLEAR_STATE = createAction('[Dual Pricing] Clear State');

export const DUAL_PRICING_UPDATE_LOADING = createAction('[Dual Pricing] Update Loading', props<{ loading: boolean }>());
